<app-toast [toastModel]="toastModel" *ngIf="isToastShow"></app-toast>
<div class="modal-header impact-outcome-header">
    <div class="modal-title f-20">Bulk Update</div>
    <div class="modal-btn-right">
        <div class="btn-group mr-4">
            <button class="btn btn-blue text-white btn-sm mr-2" (click)="updateImpactAssessment()">Save</button>
        </div>
        <button class="fa fa-times" [mat-dialog-close]=""
            style="float: right;cursor: pointer;background: none;border:none" aria-hidden="true"></button>
    </div>
</div>

<div class="modal-body" style="height: 750px;overflow: auto;">
    <div class="pl-2 ia-details-div">
        <app-progress-bar [isLoading]="isLoadingDD"></app-progress-bar>
        <mat-accordion id="AssessmentDetails">
            <mat-expansion-panel [expanded]="true" class="ia-expansion-panel pl-2 mt-2">
                <mat-expansion-panel-header class="ia-mat-panel">
                    <mat-panel-title>
                        <span class="text-header inc-f">
                            Assessment Details
                        </span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row ml-2 my-4">
                    <!-- <div class="col-lg-2">
                        <label class="control-label fw">Division</label>
                        <ng-select *ngIf="searchedJuris.length > 0" [items]="searchedJuris" bindLabel="name"
                            appendTo="body" (change)="onSelectJuris($event)" [(ngModel)]="selectedJuris">
                        </ng-select>
                    </div> -->
                    <div class="col-lg-2">
                        <label class="control-label fw">Division</label>
                        <ng-select disabled *ngIf="searchedJuris.length > 0" [items]="searchedJuris" bindLabel="name"
                          appendTo="body" [multiple]="true" [(ngModel)]="selectedJuris">
                        </ng-select>
                      </div>
                    <div class="col-lg-4">
                        <label class="control-label fw">Assessor</label>
                        <mat-chip-grid #assessorList>
                            <mat-chip-row *ngFor="let assessor of assessorDD" [selectable]="selectable"
                                [removable]="removable" (removed)="removeAssessor(assessor)">
                                {{assessor}}
                                <mat-icon matChipRemove *ngIf="removable && isADetailPermission" class="clear-icons">
                                    X
                                </mat-icon>
                            </mat-chip-row>
                            <input class="form-control form-control-sm mat-autodd-input border-bottom"
                                #trigautoAssessor="matAutocompleteTrigger"
                                (keydown)="getFilteredData('Assessor', $event)"
                                [attr.disabled]="!isADetailPermission ? 'disabled' : null" #assessorInput
                                [formControl]="searchAssessorCntrl" [matAutocomplete]="assessorAutocomplete"
                                [matChipInputFor]="assessorList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
                                (matChipInputTokenEnd)="addAssessor($event)">
                        </mat-chip-grid>
                        <mat-autocomplete #assessorAutocomplete="matAutocomplete"
                            (optionSelected)="selectedAssessorEvent($event)">
                            <mat-option *ngFor="let assessor of searchedAssessor" [value]="assessor.value">
                                {{assessor.name}}
                            </mat-option>
                        </mat-autocomplete>
                    </div>
                </div>
                <div class="row ml-2 my-4">
                    <div class="col-lg-12">
                        <div class="box-shadow p-2">
                            <div class="header-text">
                                <span class="fa fa-chevron-down cursor-pointer" *ngIf="!isIADetails1"
                                    (click)="isIADetails1 = true"></span>
                                <span class="fa fa-chevron-up cursor-pointer" *ngIf="isIADetails1"
                                    (click)="isIADetails1 = false"></span>
                                <span class="control-label fw">
                                    Description Objective
                                </span>
                            </div>
                            <app-ck-editor [(childVariable)]="impactAssessment.assessmentDetails" id="assessmentDetails" class="f-16" *ngIf="isADetailPermission && isIADetails1"></app-ck-editor>
                            <!-- <ckeditor [editor]="Editor" id="assessmentDetails" class="f-16"
                                *ngIf="isADetailPermission && isIADetails1"
                                [(ngModel)]="impactAssessment.assessmentDetails">
                            </ckeditor > -->
                        </div>
                    </div>
                </div>
                <div class="row ml-2 my-4">
                    <div class="col-lg-4">
                        <label class="control-label fw">Category</label>
                        <input type="text" class="form-control form-control-sm"
                            [attr.disabled]="!isADetailPermission ? 'disabled' : null"
                            [(ngModel)]="impactAssessment.ruleTopic">
                    </div>
                    <div class="col-lg-4">
                        <label class="control-label fw">Actual Status / Stage </label>
                        <input type="text" class="form-control form-control-sm"
                            [attr.disabled]="!isADetailPermission ? 'disabled' : null"
                            [(ngModel)]="impactAssessment.assessmentStatus">
                    </div>
                    <div class="col-lg-4">
                        <label class="control-label fw">Binding or Non-Binding</label>
                        <select class="form-control form-control-sm"
                            [attr.disabled]="!isADetailPermission ? 'disabled' : null"
                            [(ngModel)]="impactAssessment.ruleType">
                            <option value="binding">Binding</option>
                            <option value="nonBinding">Non-Binding</option>
                        </select>
                    </div>
                </div>

                <div class="row ml-2 mt-1">
                    <div class="col-lg-6">
                        <label class="control-label fw">Forseen Application</label>
                        <div class="input-group input-group-sm">
                            <input matInput [matDatepicker]="applicationDate"
                                [attr.disabled]="!isADetailPermission ? 'disabled' : null"
                                (click)="applicationDate.open()" class="form-control form-control-sm border-bottom"
                                [(ngModel)]="impactAssessment.applicationDate" name="ApplicationDate" />
                            <div class="input-group-append">
                                <span class="input-group-text fa fa-calendar" *ngIf="isADetailPermission"
                                    (click)="applicationDate.open()"></span>
                                <span class="input-group-text fa fa-calendar" *ngIf="!isADetailPermission"></span>
                            </div>
                        </div>
                        <mat-datepicker #applicationDate></mat-datepicker>
                    </div>
                    <div class="col-lg-6">
                        <label class="control-label fw">Date Last Update</label>
                        <div class="input-group input-group-sm">
                            <input matInput [matDatepicker]="lastUpdate"
                                [attr.disabled]="!isADetailPermission ? 'disabled' : null" (click)="lastUpdate.open()"
                                class="form-control form-control-sm border-bottom"
                                [(ngModel)]="impactAssessment.lastUpdate" name="LastUpdate" />
                            <div class="input-group-append">
                                <span class="input-group-text fa fa-calendar" *ngIf="isADetailPermission"
                                    (click)="lastUpdate.open()"></span>
                                <span class="input-group-text fa fa-calendar" *ngIf="!isADetailPermission"></span>
                            </div>
                        </div>
                        <mat-datepicker #lastUpdate></mat-datepicker>
                    </div>
                </div>
                <div class="row ml-2 mt-1">
                    <div class="col-lg-3">
                        <label class="control-label fw">Corporate Governance
                            <span class="label label-default bg-default p5-20"
                                *ngIf="!impactAssessment.corporateGovernance">None</span>
                            <span class="label label-default bg-red p5-20"
                                *ngIf="impactAssessment.corporateGovernance === 'High'">High</span>
                            <span class="label ml-2 label-default bg-orange p5-20"
                                *ngIf="impactAssessment.corporateGovernance === 'Medium'">Medium</span>
                            <span class="label ml-2 label-default bg-yellow p5-20"
                                *ngIf="impactAssessment.corporateGovernance === 'Low'">Low</span>
                            <span class="label ml-2 label-default bg-info p5-20"
                                *ngIf="impactAssessment.corporateGovernance === 'N/A'">N/A</span>
                            <span class="label ml-2 label-default bg-green p5-20"
                                *ngIf="impactAssessment.corporateGovernance === 'Impact Not yet'">Impact Not yet</span>
                            <span class="label ml-2 label-default bg-primary p5-20"
                                *ngIf="impactAssessment.corporateGovernance === 'Determined'">Determined</span>
                        </label>
                        <select class="form-control form-control-sm"
                            [attr.disabled]="!isADetailPermission ? 'disabled' : null"
                            [(ngModel)]="impactAssessment.corporateGovernance">
                            <option *ngFor="let option of dropdownData" value="{{option.name}}">{{option.name}}</option>
                        </select>
                    </div>
                    <div class="col-lg-3">
                        <label class="control-label fw">Sales & CS
                            <span class="label label-default bg-default p5-20"
                                *ngIf="!impactAssessment.salesCs">None</span>
                            <span class="label label-default bg-red p5-20"
                                *ngIf="impactAssessment.salesCs === 'High'">High</span>
                            <span class="label ml-2 label-default bg-orange p5-20"
                                *ngIf="impactAssessment.salesCs === 'Medium'">Medium</span>
                            <span class="label ml-2 label-default bg-yellow p5-20"
                                *ngIf="impactAssessment.salesCs === 'Low'">Low</span>
                            <span class="label ml-2 label-default bg-info p5-20"
                                *ngIf="impactAssessment.salesCs === 'N/A'">N/A</span>
                            <span class="label ml-2 label-default bg-green p5-20"
                                *ngIf="impactAssessment.salesCs === 'Impact Not yet'">Impact Not yet</span>
                            <span class="label ml-2 label-default bg-primary p5-20"
                                *ngIf="impactAssessment.salesCs === 'Determined'">Determined</span>
                        </label>
                        <select class="form-control form-control-sm"
                            [attr.disabled]="!isADetailPermission ? 'disabled' : null"
                            [(ngModel)]="impactAssessment.salesCs">
                            <option *ngFor="let option of dropdownData" value="{{option.name}}">{{option.name}}</option>
                        </select>
                    </div>
                    <div class="col-lg-3">
                        <label class="control-label fw">Pricing & UW & Data
                            <span class="label label-default bg-default p5-20"
                                *ngIf="!impactAssessment.pricingUwData">None</span>
                            <span class="label label-default bg-red p5-20"
                                *ngIf="impactAssessment.pricingUwData === 'High'">High</span>
                            <span class="label ml-2 label-default bg-orange p5-20"
                                *ngIf="impactAssessment.pricingUwData === 'Medium'">Medium</span>
                            <span class="label ml-2 label-default bg-yellow p5-20"
                                *ngIf="impactAssessment.pricingUwData === 'Low'">Low</span>
                            <span class="label ml-2 label-default bg-info p5-20"
                                *ngIf="impactAssessment.pricingUwData === 'N/A'">N/A</span>
                            <span class="label ml-2 label-default bg-green p5-20"
                                *ngIf="impactAssessment.pricingUwData === 'Impact Not yet'">Impact Not yet</span>
                            <span class="label ml-2 label-default bg-primary p5-20"
                                *ngIf="impactAssessment.pricingUwData === 'Determined'">Determined</span>
                        </label>
                        <select class="form-control form-control-sm"
                            [attr.disabled]="!isADetailPermission ? 'disabled' : null"
                            [(ngModel)]="impactAssessment.pricingUwData">
                            <option *ngFor="let option of dropdownData" value="{{option.name}}">{{option.name}}</option>
                        </select>
                    </div>
                    <div class="col-lg-3">
                        <label class="control-label fw">Finance
                            <span class="label label-default bg-default p5-20"
                                *ngIf="!impactAssessment.finance">None</span>
                            <span class="label label-default bg-red p5-20"
                                *ngIf="impactAssessment.finance === 'High'">High</span>
                            <span class="label ml-2 label-default bg-orange p5-20"
                                *ngIf="impactAssessment.finance === 'Medium'">Medium</span>
                            <span class="label ml-2 label-default bg-yellow p5-20"
                                *ngIf="impactAssessment.finance === 'Low'">Low</span>
                            <span class="label ml-2 label-default bg-info p5-20"
                                *ngIf="impactAssessment.finance === 'N/A'">N/A</span>
                            <span class="label ml-2 label-default bg-green p5-20"
                                *ngIf="impactAssessment.finance === 'Impact Not yet'">Impact Not yet</span>
                            <span class="label ml-2 label-default bg-primary p5-20"
                                *ngIf="impactAssessment.finance === 'Determined'">Determined</span>
                        </label>
                        <select class="form-control form-control-sm"
                            [attr.disabled]="!isADetailPermission ? 'disabled' : null"
                            [(ngModel)]="impactAssessment.finance">
                            <option *ngFor="let option of dropdownData" value="{{option.name}}">{{option.name}}</option>
                        </select>
                    </div>
                </div>
                <div class="row ml-2 mt-1">
                    <div class="col-lg-3">
                        <label class="control-label fw">People Services
                            <span class="label label-default bg-default p5-20"
                                *ngIf="!impactAssessment.peopleServices">None</span>
                            <span class="label label-default bg-red p5-20"
                                *ngIf="impactAssessment.peopleServices === 'High'">High</span>
                            <span class="label ml-2 label-default bg-orange p5-20"
                                *ngIf="impactAssessment.peopleServices === 'Medium'">Medium</span>
                            <span class="label ml-2 label-default bg-yellow p5-20"
                                *ngIf="impactAssessment.peopleServices === 'Low'">Low</span>
                            <span class="label ml-2 label-default bg-info p5-20"
                                *ngIf="impactAssessment.peopleServices === 'N/A'">N/A</span>
                            <span class="label ml-2 label-default bg-green p5-20"
                                *ngIf="impactAssessment.peopleServices === 'Impact Not yet'">Impact Not yet</span>
                            <span class="label ml-2 label-default bg-primary p5-20"
                                *ngIf="impactAssessment.peopleServices === 'Determined'">Determined</span>
                        </label>
                        <select class="form-control form-control-sm"
                            [attr.disabled]="!isADetailPermission ? 'disabled' : null"
                            [(ngModel)]="impactAssessment.peopleServices">
                            <option *ngFor="let option of dropdownData" value="{{option.name}}">{{option.name}}</option>
                        </select>
                    </div>
                    <div class="col-lg-3">
                        <label class="control-label fw">Claims
                            <span class="label label-default bg-default p5-20"
                                *ngIf="!impactAssessment.claims">None</span>
                            <span class="label label-default bg-red p5-20"
                                *ngIf="impactAssessment.claims === 'High'">High</span>
                            <span class="label ml-2 label-default bg-orange p5-20"
                                *ngIf="impactAssessment.claims === 'Medium'">Medium</span>
                            <span class="label ml-2 label-default bg-yellow p5-20"
                                *ngIf="impactAssessment.claims === 'Low'">Low</span>
                            <span class="label ml-2 label-default bg-info p5-20"
                                *ngIf="impactAssessment.claims === 'N/A'">N/A</span>
                            <span class="label ml-2 label-default bg-green p5-20"
                                *ngIf="impactAssessment.claims === 'Impact Not yet'">Impact Not yet</span>
                            <span class="label ml-2 label-default bg-primary p5-20"
                                *ngIf="impactAssessment.claims === 'Determined'">Determined</span>
                        </label>
                        <select class="form-control form-control-sm"
                            [attr.disabled]="!isADetailPermission ? 'disabled' : null"
                            [(ngModel)]="impactAssessment.claims">
                            <option *ngFor="let option of dropdownData" value="{{option.name}}">{{option.name}}</option>
                        </select>
                    </div>
                    <div class="col-lg-3">
                        <label class="control-label fw">Product & Ancillaries
                            <span class="label label-default bg-default p5-20"
                                *ngIf="!impactAssessment.productAncillaries">None</span>
                            <span class="label label-default bg-red p5-20"
                                *ngIf="impactAssessment.productAncillaries === 'High'">High</span>
                            <span class="label ml-2 label-default bg-orange p5-20"
                                *ngIf="impactAssessment.productAncillaries === 'Medium'">Medium</span>
                            <span class="label ml-2 label-default bg-yellow p5-20"
                                *ngIf="impactAssessment.productAncillaries === 'Low'">Low</span>
                            <span class="label ml-2 label-default bg-info p5-20"
                                *ngIf="impactAssessment.productAncillaries === 'N/A'">N/A</span>
                            <span class="label ml-2 label-default bg-green p5-20"
                                *ngIf="impactAssessment.productAncillaries === 'Impact Not yet'">Impact Not yet</span>
                            <span class="label ml-2 label-default bg-primary p5-20"
                                *ngIf="impactAssessment.productAncillaries === 'Determined'">Determined</span>
                        </label>
                        <select class="form-control form-control-sm"
                            [attr.disabled]="!isADetailPermission ? 'disabled' : null"
                            [(ngModel)]="impactAssessment.productAncillaries">
                            <option *ngFor="let option of dropdownData" value="{{option.name}}">{{option.name}}</option>
                        </select>
                    </div>
                    <div class="col-lg-3">
                        <label class="control-label fw">EUIGS
                            <span class="label label-default bg-default p5-20"
                                *ngIf="!impactAssessment.euigs">None</span>
                            <span class="label label-default bg-red p5-20"
                                *ngIf="impactAssessment.euigs === 'High'">High</span>
                            <span class="label ml-2 label-default bg-orange p5-20"
                                *ngIf="impactAssessment.euigs === 'Medium'">Medium</span>
                            <span class="label ml-2 label-default bg-yellow p5-20"
                                *ngIf="impactAssessment.euigs === 'Low'">Low</span>
                            <span class="label ml-2 label-default bg-info p5-20"
                                *ngIf="impactAssessment.euigs === 'N/A'">N/A</span>
                            <span class="label ml-2 label-default bg-green p5-20"
                                *ngIf="impactAssessment.euigs === 'Impact Not yet'">Impact Not yet</span>
                            <span class="label ml-2 label-default bg-primary p5-20"
                                *ngIf="impactAssessment.euigs === 'Determined'">Determined</span>
                        </label>
                        <select class="form-control form-control-sm"
                            [attr.disabled]="!isADetailPermission ? 'disabled' : null"
                            [(ngModel)]="impactAssessment.euigs">
                            <option *ngFor="let option of dropdownData" value="{{option.name}}">{{option.name}}</option>
                        </select>
                    </div>
                </div>
                <div class="row ml-2 mt-1">
                    <div class="col-lg-4">
                        <label class="control-label fw">Marketing & Communications
                            <span class="label label-default bg-default p5-20"
                                *ngIf="!impactAssessment.marketingCommunication">None</span>
                            <span class="label label-default bg-red p5-20"
                                *ngIf="impactAssessment.marketingCommunication === 'High'">High</span>
                            <span class="label ml-2 label-default bg-orange p5-20"
                                *ngIf="impactAssessment.marketingCommunication === 'Medium'">Medium</span>
                            <span class="label ml-2 label-default bg-yellow p5-20"
                                *ngIf="impactAssessment.marketingCommunication === 'Low'">Low</span>
                            <span class="label ml-2 label-default bg-info p5-20"
                                *ngIf="impactAssessment.marketingCommunication === 'N/A'">N/A</span>
                            <span class="label ml-2 label-default bg-green p5-20"
                                *ngIf="impactAssessment.marketingCommunication === 'Impact Not yet'">Impact Not
                                yet</span>
                            <span class="label ml-2 label-default bg-primary p5-20"
                                *ngIf="impactAssessment.marketingCommunication === 'Determined'">Determined</span>
                        </label>
                        <select class="form-control form-control-sm"
                            [attr.disabled]="!isADetailPermission ? 'disabled' : null"
                            [(ngModel)]="impactAssessment.marketingCommunication">
                            <option *ngFor="let option of dropdownData" value="{{option.name}}">{{option.name}}</option>
                        </select>
                    </div>
                    <div class="col-lg-4">
                        <label class="control-label fw">AECS Madrid
                            <span class="label label-default bg-default p5-20"
                                *ngIf="!impactAssessment.aecsMadrid">None</span>
                            <span class="label label-default bg-red p5-20"
                                *ngIf="impactAssessment.aecsMadrid === 'High'">High</span>
                            <span class="label ml-2 label-default bg-orange p5-20"
                                *ngIf="impactAssessment.aecsMadrid === 'Medium'">Medium</span>
                            <span class="label ml-2 label-default bg-yellow p5-20"
                                *ngIf="impactAssessment.aecsMadrid === 'Low'">Low</span>
                            <span class="label ml-2 label-default bg-info p5-20"
                                *ngIf="impactAssessment.aecsMadrid === 'N/A'">N/A</span>
                            <span class="label ml-2 label-default bg-green p5-20"
                                *ngIf="impactAssessment.aecsMadrid === 'Impact Not yet'">Impact Not yet</span>
                            <span class="label ml-2 label-default bg-primary p5-20"
                                *ngIf="impactAssessment.aecsMadrid === 'Determined'">Determined</span>
                        </label>
                        <select class="form-control form-control-sm"
                            [attr.disabled]="!isADetailPermission ? 'disabled' : null"
                            [(ngModel)]="impactAssessment.aecsMadrid">
                            <option *ngFor="let option of dropdownData" value="{{option.name}}">{{option.name}}</option>
                        </select>
                    </div>
                    <div class="col-lg-4">
                        <label class="control-label fw">Data Protection
                            <span class="label label-default bg-default p5-20"
                                *ngIf="!impactAssessment.dataProtection">None</span>
                            <span class="label label-default bg-red p5-20"
                                *ngIf="impactAssessment.dataProtection === 'High'">High</span>
                            <span class="label ml-2 label-default bg-orange p5-20"
                                *ngIf="impactAssessment.dataProtection === 'Medium'">Medium</span>
                            <span class="label ml-2 label-default bg-yellow p5-20"
                                *ngIf="impactAssessment.dataProtection === 'Low'">Low</span>
                            <span class="label ml-2 label-default bg-info p5-20"
                                *ngIf="impactAssessment.dataProtection === 'N/A'">N/A</span>
                            <span class="label ml-2 label-default bg-green p5-20"
                                *ngIf="impactAssessment.dataProtection === 'Impact Not yet'">Impact Not yet</span>
                            <span class="label ml-2 label-default bg-primary p5-20"
                                *ngIf="impactAssessment.dataProtection === 'Determined'">Determined</span>
                        </label>
                        <select class="form-control form-control-sm"
                            [attr.disabled]="!isADetailPermission ? 'disabled' : null"
                            [(ngModel)]="impactAssessment.dataProtection">
                            <option *ngFor="let option of dropdownData" value="{{option.name}}">{{option.name}}</option>
                        </select>
                    </div>
                </div>
                <div class="row ml-2 my-4">
                    <div class="col-lg-12">
                        <div class="box-shadow p-2">
                            <div class="header-text">
                                <span class="fa fa-chevron-down cursor-pointer" *ngIf="!isIADetails1"
                                    (click)="isIADetails1 = true"></span>
                                <span class="fa fa-chevron-up cursor-pointer" *ngIf="isIADetails1"
                                    (click)="isIADetails1 = false"></span>
                                <span class="control-label fw">
                                    Admiral Seguros Compliance Monitoring
                                </span>
                            </div>
                            <app-ck-editor [(childVariable)]="impactAssessment.compAssessment" id="compAssessment" class="f-16" *ngIf="isADetailPermission && isIADetails1"></app-ck-editor>
                            <!-- <ckeditor [editor]="Editor" id="compAssessment" class="f-16" *ngIf="isADetailPermission && isIADetails1"
                                [(ngModel)]="impactAssessment.compAssessment">
                            </ckeditor> -->
                        </div>
                    </div>
                </div>
                <div class="row ml-2 my-4">
                    <div class="col-lg-12">
                        <div class="box-shadow p-2">
                            <div class="header-text">
                                <span class="fa fa-chevron-down cursor-pointer" *ngIf="!isIADetails1"
                                    (click)="isIADetails1 = true"></span>
                                <span class="fa fa-chevron-up cursor-pointer" *ngIf="isIADetails1"
                                    (click)="isIADetails1 = false"></span>
                                <span class="control-label fw">
                                    Dates/Deadlines
                                </span>
                            </div>
                            <app-ck-editor [(childVariable)]="impactAssessment.datesDeadlines" id="datesDeadlines" class="f-16" *ngIf="isADetailPermission && isIADetails1"></app-ck-editor>
                            <!-- <ckeditor [editor]="Editor" id="datesDeadlines" class="f-16" *ngIf="isADetailPermission && isIADetails1"
                                [(ngModel)]="impactAssessment.datesDeadlines">
                            </ckeditor> -->
                        </div>
                    </div>
                </div>
                <div class="row ml-2 mt-1">
                    <div class="col-lg-6">
                        <label class="control-label fw">Links with Any (Gold) Projects </label>
                        <input type="text" class="form-control form-control-sm"
                            [attr.disabled]="!isADetailPermission ? 'disabled' : null"
                            [(ngModel)]="impactAssessment.projectReference">
                    </div>
                    <div class="col-lg-6">
                        <label class="control-label fw">Resource Needed</label>
                        <input type="text" class="form-control form-control-sm"
                            [attr.disabled]="!isADetailPermission ? 'disabled' : null"
                            [(ngModel)]="impactAssessment.resourceNeeded">
                    </div>
                </div>
                <div class="row ml-2 my-4">
                    <div class="col-lg-12">
                        <div class="box-shadow p-2">
                            <div class="header-text">
                                <span class="fa fa-chevron-down cursor-pointer" *ngIf="!isIADetails1"
                                    (click)="isIADetails1 = true"></span>
                                <span class="fa fa-chevron-up cursor-pointer" *ngIf="isIADetails1"
                                    (click)="isIADetails1 = false"></span>
                                <span class="control-label fw">
                                    Admiral Seguros Bussines Action
                                </span>
                            </div>
                            <app-ck-editor [(childVariable)]="impactAssessment.businessActions"  id="businessActions" class="f-16" *ngIf="isADetailPermission && isIADetails1"></app-ck-editor>
                            <!-- <ckeditor [editor]="Editor" id="businessActions" class="f-16"
                                *ngIf="isADetailPermission && isIADetails1"
                                [(ngModel)]="impactAssessment.businessActions">
                            </ckeditor> -->
                        </div>
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </div>
</div>